import React from "react";

/**
 * Generic checklist to show requirements that must be met before an action (e.g. submit/save).
 * Renders a list of conditions; unmet ones show as warning messages, and an optional
 * success message is shown when all conditions are met.
 *
 * @param {Object} props
 * @param {Array<{ met: boolean, message: string }>} props.conditions - List of conditions. When met is false, message is shown in a warning box.
 * @param {string} [props.successMessage] - Message shown in a success box when all conditions are met.
 * @param {string} [props.className] - CSS classes for the wrapper.
 */
const Checklist = ({ conditions = [], successMessage, className = "" }) => {
  const allMet = conditions.length > 0 && conditions.every((c) => c.met);

  return (
    <div className={`${className} py-2`.trim()}>
      {conditions.map(
        (condition, index) =>
          !condition.met && (
            <div
              key={index}
              className={`overflow-hidden transition-all duration-300 ease-in-out max-h-20 opacity-100 mb-2`}
            >
              <div className="bg-yellow-100 rounded text-yellow-800 text-sm font-medium p-2">
                <p className="text-center">⚠ {condition.message}</p>
              </div>
            </div>
          )
      )}
      {successMessage && (
        <div
          className={`overflow-hidden transition-all duration-300 ease-in-out ${
            allMet ? "max-h-20 opacity-100 mb-2" : "max-h-0 opacity-0 mb-0"
          }`}
        >
          <div className="bg-green-100 rounded text-green-800 text-sm font-medium p-2">
            <p className="text-center">✓ {successMessage}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Checklist;
